import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import useSections from "@/hooks/useSections";
import { api } from "@/lib/api";

export default function Sezioni() {
  const { lang, t } = useLanguage();
  const sections = useSections();
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api
      .get("/articles")
      .then((res) => {
        const c = {};
        res.data.forEach((a) => {
          if (a.section_slug) c[a.section_slug] = (c[a.section_slug] || 0) + 1;
        });
        setCounts(c);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="sezioni-page" className="pt-24 sm:pt-32">
      <section className="bg-white">
        <div className="container-editorial pb-14">
          <Reveal>
            <p className="eyebrow">{t.sezioniPage.eyebrow}</p>
            <h1 className="mt-4 max-w-3xl font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.1] text-slate-900 tracking-tight">
              {t.sezioniPage.title}
            </h1>
            <p className="mt-6 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-slate-600">
              {t.sezioniPage.sub}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-28">
        <div className="container-editorial">
          {sections.length === 0 && (
            <p className="text-sm font-light text-slate-500">{t.sezioniPage.empty}</p>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {sections.map((s, i) => {
              const title = (lang === "en" && s.title_en) || s.title;
              const subtitle = (lang === "en" && s.subtitle_en) || s.subtitle;
              return (
                <Reveal key={s.id} delay={i * 0.05}>
                  <Link
                    to={`/sezione/${s.slug}`}
                    data-testid={`sezioni-card-${s.slug}`}
                    className="group flex flex-col h-full border border-slate-200 bg-white hover:border-brand/50 transition-colors duration-300"
                  >
                    {s.image && (
                      <div className="overflow-hidden h-48">
                        <img
                          src={s.image}
                          alt={title}
                          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                        />
                      </div>
                    )}
                    <div className="flex flex-col flex-1 p-6">
                      {subtitle && <p className="eyebrow">{subtitle}</p>}
                      <h2 className="mt-3 font-serif text-2xl leading-snug text-slate-900 group-hover:text-brand transition-colors duration-300">
                        {title}
                      </h2>
                      <div className="mt-auto pt-5 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-slate-400">
                        <span>
                          {counts[s.slug] ?? 0}{" "}
                          {(counts[s.slug] ?? 0) === 1 ? t.sezioniPage.article : t.sezioniPage.articles}
                        </span>
                        <ArrowRight className="h-4 w-4 text-brand transition-transform duration-300 group-hover:translate-x-1" />
                      </div>
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
